import { render } from "./EditableCheckboxMultiSelect.vue?vue&type=template&id=2c1d2a85"
import script from "./EditableCheckboxMultiSelect.vue?vue&type=script&lang=js"
export * from "./EditableCheckboxMultiSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__